import axios from 'axios';
import { showToast } from './components/notification';

// Ensure CSRF token is sent with every request (required for Axios 1.x)
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let sessionExpiredHandled = false;

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        if ((status === 419 || status === 401) && !sessionExpiredHandled) {
            sessionExpiredHandled = true;
            showToast('error', 'Sesiunea a expirat. Veți fi redirecționat către pagina de autentificare.');
            setTimeout(() => {
                window.location.href = '/';
            }, 1500);
        }
        return Promise.reject(error);
    },
);

export default axios;
